export const CONNECT = "CONNECT";

export const GET_WALLET = "GET_WALLET";

export const GET_METAMASK = "GET_METAMASK";

export const GET_CHAIN = "GET_CHAIN";